import { CapacitorPrint } from 'capacitor-print';
import { BleClient } from '@capacitor-community/bluetooth-le';
import { I18n, Store } from '../wrappers';
const PrintServiceAndroid = {
    async init() {
        await BleClient.initialize({ androidNeverForLocation: true });
    },
    async detectPrinters() {
        const terminal = Store.get('terminal');
        const networkPrinter = {
            terminal: terminal,
            printer: { name: 'network_printer', description: I18n.t('printers.network') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 48,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        const usbPrinter = {
            terminal: terminal,
            printer: { name: 'usb_printer', description: I18n.t('printers.usb') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 48,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        const bluetoothPrinter = {
            terminal: terminal,
            printer: { name: 'bluetooth_printer', description: I18n.t('printers.bluetooth') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        const integratedPrinter = {
            terminal: terminal,
            printer: { name: 'integrated_printer', description: I18n.t('printers.integrated') },
            options: {
                id: undefined,
                escpos: true,
                width: 48,
                height: undefined,
                margin: undefined,
                scaleFactor: undefined,
                charsPerLine: 32,
                dpi: 203,
                ipAddress: undefined,
                qrCodeSize: I18n.c('general.qrCodeSize'),
                version: 1,
                other: {}
            }
        };
        return [integratedPrinter, networkPrinter, usbPrinter, bluetoothPrinter];
    },
    async sendToPrinter(printer, data) {
        try {
            const bluetoothEnabled = await BleClient.isEnabled();
            if (!bluetoothEnabled) {
                await BleClient.enable();
                const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
                await delay(3000);
            }
        }
        catch (error) {
            console.log(error);
        }
        try {
            let permissions = await CapacitorPrint.checkPermissions();
            if (permissions.bluetooth !== 'granted') {
                permissions = await CapacitorPrint.requestPermissions();
            }
            CapacitorPrint.print({ printer, data });
        }
        catch (error) {
            return { success: false };
        }
        return { success: true };
    },
    /**
     * Open printer cash drawer
     */
    async openDrawer(printer) {
        return { success: false, error: 'not_supported' };
    },
    /**
     * Whether the installed native build prints the receipt logo line. A build from before the
     * logo has no `capabilities` method: the call rejects, which counts as no.
     */
    async canPrintLogo() {
        try {
            const capabilities = await CapacitorPrint.capabilities();
            return capabilities?.logo === true;
        }
        catch {
            return false;
        }
    },
};
export default PrintServiceAndroid;
//# sourceMappingURL=PrintServiceAndroid.js.map